module.exports = __webpack_public_path__ + "static/media/61OxWYGrH8L._AC_SL1500_.08ff050a.jpg";